import React from 'react';
import PropTypes from 'prop-types';
import app from 'new-ui/app';
import { LOCAL_STORAGE_KEYS } from 'utils/constants/localStorageKeys';
import { POPUP } from 'utils/constants/popup';
import { sendDoctorEmail } from 'modules/matches/api';
import { PopupButton, PopupContent, PopupTitle } from 'new-ui/Components/Popup';
import './SendToDoctor.css';
import { useTranslation } from 'utils/modifiedTranslation';

const SendToDoctor = ({ closePopup }) => {
  const { t } = useTranslation();
  const { email, firstName, doctorClinicFromList } = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_KEYS.DOCTOR_ADDED),
  ) ?? {};

  const send = () => {
    const data = {
      doctorFirstName: firstName || '',
      doctorEmail: email || '',
      clinicName: doctorClinicFromList || '',
      subjectLine: t('share_with_doctor.subject_line'),
      msg: `${t('share_with_doctor.message_text')}
${email}`,
    };

    app.showPreloader();
    sendDoctorEmail(data, { lang: 'en' }).then(() => {
      localStorage.setItem(LOCAL_STORAGE_KEYS.DOCTOR_SHARED, 1);
      setTimeout(() => {
        app.hidePreloader();
        closePopup();
      }, 3000);
    });
  };
  return (
    <div className="add-doctor">
      <PopupTitle title="Add your doctor's details" />
      <PopupContent>
        <p className="to-and-from">
          To:
          {' '}
          {firstName}
        </p>
        <p className="to-and-from">
          Email:
          {' '}
          {email}
        </p>
        <p
          // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
          role="button"
          tabIndex={-1}
          onClick={() => app.openPopup(POPUP.SHARE_WITH_MY_DOCTOR)}
          onKeyDown={() => app.openPopup(POPUP.SHARE_WITH_MY_DOCTOR)}
          className="someone-else"
        >
          Send to someone else
        </p>
        <p className="to-and-from">
          Are you worried about sharing trial information with your doctor?
          We get it, but you shouldn`t be. You have to remember that your doctor wants
          the best for you and is rooting for you to succeed. Presenting your oncologist
          with information about your trial matches will ensure an informed and
          productive discussion about your treatment plan.
        </p>
      </PopupContent>
      <PopupButton
        title="Next"
        action={send}
      />
    </div>
  );
};

SendToDoctor.propTypes = {
  closePopup: PropTypes.func.isRequired,
};

export default SendToDoctor;
